/**
 * @generated SignedSource<<3c191f54c00911db1922948d58edb098>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SaveResetViewSettingsButton$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonCollapsible">;
  readonly " $fragmentType": "SaveResetViewSettingsButton";
};
export type SaveResetViewSettingsButton$key = {
  readonly " $data"?: SaveResetViewSettingsButton$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButton">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "SaveResetViewSettingsButton",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "staticViewInput",
          "variableName": "staticViewInput"
        }
      ],
      "kind": "FragmentSpread",
      "name": "SaveResetViewSettingsButtonCollapsible"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "19ee174b608e439b6b5f27a48074dc27";

export default node;
